import { httpClient } from "@/lib/http-client/http-client";
import { ISpecificationFoldersContentsRequest } from "../interface/requests/ISpecificationFoldersRequest";
import { ISpecificationFoldersContentsResponse } from "../interface/responses/ISpecificationFoldersResponse";

class SpecificationFoldersService {
  constructor() { }

  async getFolderContents(data: ISpecificationFoldersContentsRequest) {
    const queryParams = new URLSearchParams();

    if (data.sortBy) queryParams.append("sortBy", data.sortBy);
    if (data.order) queryParams.append("order", data.order);
    if (data.offset !== undefined)
      queryParams.append("offset", data.offset.toString());
    if (data.limit !== undefined)
      queryParams.append("limit", data.limit.toString());
    if (data.filter) queryParams.append("filter", data.filter);
    if (data.status && data.status.length > 0) {
      data.status.forEach((statusItem) => {
        queryParams.append("status[]", statusItem);
      });
    }
    if (data.search) queryParams.append("search", data.search);

    const url = `/specification-folders/${data.companyId}/${data.folderId
      }/contents?${queryParams.toString()}`;

    const response =
      await httpClient.get<ISpecificationFoldersContentsResponse>(url);
    return response;
  }

  async getFolderTree(data: {
    companyId: string;
    offset?: number;
    limit?: number;
    sortBy?: string;
    search?: string;
  }) {
    const queryParams = new URLSearchParams();

    if (data.offset !== undefined)
      queryParams.append("offset", data.offset.toString());
    if (data.limit !== undefined)
      queryParams.append("limit", data.limit.toString());
    if (data.sortBy) queryParams.append("sortBy", data.sortBy);
    if (data.search) queryParams.append("search", data.search);

    const url = `/specification-folders/${data.companyId}?${queryParams.toString()}`;

    const response =
      await httpClient.get<ISpecificationFoldersContentsResponse>(url);
    return response;
  }
}

export const specificationFoldersService = new SpecificationFoldersService();
export default SpecificationFoldersService;

